import api from "./api";
import { IAdiantamentoEvento } from "../interfaces/adiantamento";

type CreateAdiantamentoProps = {
  eventoId: number;
  data: IAdiantamentoEvento;
  file?: File | null;
};

type EditAdiantamentoProps = {
  eventoId: number;
  data: IAdiantamentoEvento;
};

export async function uploadFileAdiantamento(
  file: File,
  filenameOld: string = null
): Promise<string> {
  try {
    // Cria uma instância de FormData e adiciona o arquivo selecionado
    // como um campo chamado 'comprovante'
    const formData = new FormData();
    formData.append("comprovante", file);

    // Fazer o upload do comprovante do adiantamento
    const response = await api.post(
      "/adiantamento/upload-comprovante",
      formData
    );

    // Checar se exite um arquivo já enviado, caso tenha deletar
    if (filenameOld) {
      deleteFileComprovanteAdiantamento(filenameOld);
    }
    // Retorna o filename do arquivo criado
    return response.data.urlComprovante;
  } catch (error) {
    throw new Error("Erro ao fazer o upload do comprovante");
  }
}

export async function deleteFileComprovanteAdiantamento(filename: string) {
  try {
    return await api.delete(`/adiantamento/comprovante/${filename}`);
  } catch (error) {
    throw new Error("Erro ao deletar o comprovante");
  }
}

export async function createAdiantamentoEvento({
  eventoId,
  data,
  file,
}: CreateAdiantamentoProps) {
  let filenameUrlComprovante = data.urlComprovante?.trim() || "";

  if (file) {
    filenameUrlComprovante = await uploadFileAdiantamento(file);
  }

  const dataAdiantamento: IAdiantamentoEvento = {
    ...data,
    urlComprovante: filenameUrlComprovante,
    valorTransacao: Number(data.valorTransacao),
    eventoId,
  };

  try {
    // Envia os dados de adiantamento para a API - Salvar no banco
    const { data, status, statusText } = await api.post(
      "/adiantamento",
      dataAdiantamento
    );
    return { data, status, statusText };
  } catch (error) {
    throw new Error("Erro ao cadastrar o adiantamento");
  }
}

export async function editAdiantamentoEvento({
  data,
  eventoId,
}: EditAdiantamentoProps) {
  const dataEdit = {
    ...data,
    valorTransacao: Number(data.valorTransacao),
    eventoId,
  };

  try {
    const { data, status, statusText } = await api.put(
      `/adiantamento`,
      dataEdit
    );
    return { data, status, statusText };
  } catch (error) {
    throw new Error("Erro ao editar o adiantamento");
  }
}

export async function deleteAdiantamentoEvento(adiantId: number) {
  try {
    return await api.delete(`/adiantamento/${adiantId}`);
  } catch (error) {
    throw new Error("Erro ao excluir o adiantamento");
  }
}
